import { DOCUMENT, isPlatformServer } from "@angular/common";
import {
  Inject,
  Injectable,
  Optional,
  PLATFORM_ID
} from "@angular/core";

import { REQUEST } from "../../../express.tokens";
import { Request } from "express";

@Injectable({
  providedIn: "root"
})
export class CookieService {
  isServer = isPlatformServer(this.platformId);

  constructor(
    @Optional() @Inject(REQUEST) private request: Request,
    @Inject(PLATFORM_ID) private platformId: any,
    @Inject(DOCUMENT) private _document: Document
  ) {}

  setCookie(name: string, value: string, days: number): void {
    let expiryDate = "";
    let maxAge;

    if (days) {
      const date = new Date();

      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);

      expiryDate = `; expires=" ${date.toUTCString()}`;

      maxAge = 60 * 60 * 24 * days;
    }

    this._document.cookie = `${name}=${value || ""}${expiryDate}; max-age=${maxAge}; path=/`;
  }

  getCookie(name: string): string | null {
    const cookieName = name + "=";
    let cookieArray: string[] | undefined;

    if (this.isServer) {
      cookieArray = this.request.headers.cookie?.split(";");
    } else {
      cookieArray = document.cookie.split(";");
    }

    if (cookieArray) {
      for (let i = 0; i < cookieArray.length; i++) {
        let cookieItem = cookieArray[i];

        while (cookieItem.charAt(0) === " ") {
          cookieItem = cookieItem.substring(1, cookieItem.length);
        }

        if (cookieItem.indexOf(cookieName) === 0) {
          return cookieItem.substring(cookieName.length, cookieItem.length);
        }
      }
    }

    return null;
  }

  eraseCookie(name: string): void {
    this._document.cookie = name + `=; Max-Age=-99999999; path=/;`;
  }
}
